











import Vue, { PropType } from 'vue'
import XChip, { ChipProps } from './XChip.vue'

type StatusLabelVariant =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'warning'
  | 'important'
  | 'info'
  | 'light'
  | 'dark'
  | 'link'

// TODO スタイル調整
const variantProps: {
  [key in StatusLabelVariant]: Partial<ChipProps & { class: string }>
} = {
  primary: { class: 'text-white bg-primary' },
  secondary: { class: 'text-white bg-secondary' },
  success: { class: 'text-white bg-green-500' },
  warning: { class: 'text-white bg-yellow-500' },
  important: { class: 'text-white bg-red-500' },
  info: {},
  light: {},
  dark: {},
  link: {},
}

type Props = {
  value: string
  enum: Record<string | number, string>
  variant?: StatusLabelVariant
  variantMap?: { [key: string]: StatusLabelVariant }
}

/**
 * @example
 * - template例
 * <x-status-label :value="item.status" :enum="{ AgentSalesOrderStatus }" />
 *
 * - メッセージリソース定義例（enum名のlowerCamelCaseをキーとする）
 * enums: {
 *   agentSalesOrderStatus: {
 *     new: '新規',
 *     charged: '決済済',
 *     canceled: 'キャンセル済',
 *   },
 *   ...
 * }
 */
export default Vue.extend<{}, {}, {}, Props>({
  components: { XChip },
  inheritAttrs: false,
  name: 'XStatusLabel',
  props: {
    value: {
      type: String,
      required: true,
    },
    enum: {
      type: Object,
      required: true,
      validator(value) {
        return Object.keys(value).length === 1
      },
    },
    variant: {
      type: String as PropType<StatusLabelVariant>,
    },
    variantMap: {
      type: Object as PropType<{ [key: string]: StatusLabelVariant }>,
      // 複数値一括設定用(status => variant)
    },
  },
  computed: {
    enumName() {
      return Object.keys(this.enum)[0]
    },
    attrs() {
      let variant: StatusLabelVariant = 'light'
      if (this.variant) {
        variant = this.variant
      } else if (this.variantMap && this.value in this.variantMap) {
        variant = this.variantMap[this.value]
      }
      return variantProps[variant]
    },
  },
})
